module.exports = __webpack_public_path__ + "img/index1.f40fad78.png";